import { Controller } from '@hotwired/stimulus'
import { formFields, type SegmentRoutes, segmentDestination, tidySearch } from '@/lib/search-form'

export default class extends Controller<HTMLFormElement> {
  static override values = { list: String, segments: Array }

  declare readonly listValue: string
  declare readonly segmentsValue: SegmentRoutes

  route() {
    this.element.action =
      segmentDestination(formFields(this.element), this.segmentsValue)?.path ?? this.listValue
  }

  prune({ formData }: FormDataEvent) {
    tidySearch(formData)
    if (formData.get('modality') !== 'in_person') formData.delete('city')
    const destination = segmentDestination(formData, this.segmentsValue)
    for (const field of destination?.carried ?? []) formData.delete(field)
  }
}
